import React from 'react';
import './IndustryCard.css';
import { Link } from 'react-router-dom';

const IndustryCard = ({ title, description, route }) => {
  return (
    <div className="industry-card">
      <h3>{title}</h3>
      <p>{description}</p>
      <div className="industry-footer">
        <Link to={route} className="explore-link">
          <span className="arrow">→</span>
          <span className="explore">Explore</span>
        </Link>
      </div>
    </div>
  );
};

export default IndustryCard;